import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import AboutPreview from './components/AboutPreview';
import FAQSection from './components/FAQSection';

const homeSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '重生萝莉岛',
    url: 'https://chongshengluolidao.com',
    description: '重生萝莉岛是一款以神秘岛屿为背景的重生冒险题材内容平台，融合萌系角色与奇幻剧情，带你体验全新世界的惊喜与成长。',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '重生萝莉岛',
    url: 'https://chongshengluolidao.com',
    description: '萌系重生冒险内容平台',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '重生萝莉岛——全新冒险等你开启',
    description: '重生萝莉岛是一款以神秘岛屿为背景的重生冒险题材内容平台，融合萌系角色与奇幻剧情。',
    url: 'https://chongshengluolidao.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '重生萝莉岛',
      url: 'https://chongshengluolidao.com',
    },
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '重生萝莉岛是什么类型的游戏？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '重生萝莉岛是一款以神秘岛屿为背景的重生冒险题材角色扮演游戏，融合了萌系角色养成、奇幻剧情探索、战斗冒险等多种元素。',
        },
      },
      {
        '@type': 'Question',
        name: '新手应该从哪里开始玩？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '建议新手从启程之村开始，按照主线任务逐步推进。同时可以参考攻略区的"新手入门完全攻略"文章。',
        },
      },
      {
        '@type': 'Question',
        name: '重生萝莉岛有多少个可招募的伙伴？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前版本共有12位可招募的伙伴角色，包括4位主线必得伙伴、5位支线招募伙伴和3位隐藏伙伴。',
        },
      },
      {
        '@type': 'Question',
        name: '重生机制有什么特殊之处？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '每次"死亡"后会在生命石碑处重生并保留部分经验值。随着重生次数增加，角色会逐渐觉醒特殊能力。这体现了"失败是新的开始"的积极主题。',
        },
      },
      {
        '@type': 'Question',
        name: '如何快速提升等级？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '优先推进主线任务获取丰厚经验，中期利用副本刷级配合组队加成，后期通过每日委托稳定获取经验。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEO
        title="重生萝莉岛——全新冒险等你开启 | 萌系重生奇幻岛屿"
        description="重生萝莉岛是一款以神秘岛屿为背景的重生冒险题材内容平台，融合萌系角色与奇幻剧情，带你体验全新世界的惊喜与成长。探索重生萝莉岛的独特魅力，感受每一次重生带来的无限可能与热血剧情。"
        keywords="重生萝莉岛,重生萝莉岛攻略,重生萝莉岛剧情,重生萝莉岛角色,萝莉岛冒险,重生奇幻岛屿,萌系重生故事"
        canonicalUrl="https://chongshengluolidao.com"
        jsonLd={homeSchemas}
      />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <AboutPreview />
        <FAQSection />
      </main>
    </>
  );
}